export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/rushing-icon.svg?a6fc9c460d0598538acdfd6a3f03db1f";